import { useQuery } from 'hooks/useCustomQuery';
import getAddressess from '@/API/Addresses/getAddressess';
import useAddress from '../../hooks/useAddress';

const useGetAddresses = (currentCompany, setAddresses) => {
    const { concatAddressFields } = useAddress();

    return useQuery({
        queryKey: ['addresses', currentCompany],
        queryFn: async () => {
            const data = await getAddressess(currentCompany).then((res) => {
                const addresses = res
                    .map((address) => {
                        const addressConcated = concatAddressFields(address);
                        const description = address.description?.length
                            ? `${address.description} - ${addressConcated}`
                            : addressConcated;

                        return {
                            ...address,
                            address: description,
                            description,
                        };
                    })
                    .concat({ description: '–Company Default–', id: null });
                setAddresses(addresses);
                return addresses;
            });
            return data;
        },
        refetchOnWindowFocus: false,
        enabled: !!currentCompany,
        staleTime: 0,
    });
};

export default useGetAddresses;
